import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const GapSection = () => {
    return (
        <Box
            component="section"
            id="gap"
            aria-labelledby="gap-heading"
            sx={{
                py: { xs: 7, md: 8, lg: 8.5 },
                background: 'linear-gradient(180deg, #121826 0%, #171E2E 55%, #121826 100%)',
                borderTop: '1px solid rgba(148, 163, 184, 0.18)',
                borderBottom: '1px solid rgba(148, 163, 184, 0.18)',
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', maxWidth: 720, mx: 'auto'}}>
                <Typography
                        component="span"
                        sx={{
                            display: 'inline-block',
                            fontSize: { xs: '0.6875rem', sm: '0.75rem' },
                            fontWeight: 700,
                            letterSpacing: '0.18em',
                            textTransform: 'uppercase',
                            color: '#0066FF',
                            bgcolor: 'rgba(0, 102, 255, 0.1)',
                            px: { xs: 1.75, sm: 2.25 },
                            py: 0.75,
                            borderRadius: 999,
                            mb: 2.5,
                        }}
                    >
                        The gap
                    </Typography>
                </Box>
                <Typography
                    id="gap-heading"
                    variant="h2"
                    sx={{
                        fontSize: { xs: '1.75rem', sm: '2.125rem', md: '2.5rem' },
                        fontWeight: 800,
                        lineHeight: 1.18,
                        letterSpacing: '-0.03em',
                        color: '#F8FAFC',
                        mb: 3,
                        maxWidth: '24ch',
                        textAlign: 'center',
                        mx: 'auto',
                    }}
                >
                    Clinic software wasn't built for this.
                </Typography>

                <Typography
                    component="p"
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem' },
                        lineHeight: 1.75,
                        color: 'rgba(226, 232, 240, 0.9)',
                        m: 0,
                        // mx: 'auto',
                        textAlign: 'center',
                        // maxWidth: '47rem',
                    }}
                >
                    If you've looked at clinic software and wondered whether it could work for field
                    teams, it can't. Clinic software tracks what happens inside your facility. It has no
                    concept of a home visit. It can't verify a therapist was at a specific location. It
                    can't link a confirmed visit to a payout calculation. These aren't missing
                    features. The workflow simply wasn't designed for field operations.
                </Typography>

                <Typography
                    component="p"
                    sx={{
                        mt: 3,
                        fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem' },
                        fontWeight: 700,
                        color: '#E2E8F0',
                        letterSpacing: '-0.01em',
                    }}
                >
                    {/* meDZhub was. */}
                </Typography>
            </Container>
        </Box>
    );
};

export default GapSection;
